// 日本語. 1次ドラフト — ネイティブ校正推奨（敬語・助詞）。
export default {
  common: {
    save: "保存",
    cancel: "キャンセル",
    close: "閉じる",
    comingSoon: "準備中です",
  },
  brand: { name: "バーチュペット", title: "バーチュペット スタジオ" },
  auth: {
    loginRequired: "ログイン情報がありません。ログイン画面に戻ります。",
  },
  login: {
    tabStreamer: "配信者",
    tabFan: "ファン",
    fanWelcome: "ファンとして参加 🎉",
    fanSubtitle: "推しの配信者のペットに送るリアクションを作ろう。",
    fanComingSoon: "ファンログインは近日公開。",
    welcome: "ようこそ 🌈",
    subtitle: "かわいい仲間たちが待っています。ログインしてください 🐶",
    discord: "Discordでログイン",
    email: "メールでログイン",
    submit: "ログイン",
    errExpired: "有効期限が切れたアカウントです。管理者にお問い合わせください。",
    errNotFound: "メールアドレスまたはパスワードが正しくありません",
    errUnknown: "不明なエラーが発生しました",
    errDiscord: "Discordログインに失敗しました",
  },
  nav: {
    home: "ホーム",
    broadcastSection: "配信",
    broadcastManage: "プラットフォーム連携",
    broadcast: "配信する",
    broadcastGame: "配信ゲーム",
    petSetting: "ペット設定",
    prepare: "MOD",
    makeReaction: "リアクション作成",
    upload: "音楽・字幕アップロード",
    myVirtupet: "マイバーチュペット",
    myItems: "所持アイテム",
    training: "トレーニング",
    motion: "リアクション",
    viewerAffinity: "視聴者親密度",
    world: "バーチュペットワールド",
    petStore: "ペットストア",
    hospital: "病院",
    ranking: "ランキング",
    gather: "にんじんベッティング",
    sns: "ソーシャル",
    socialBroadcast: "配信キャンバス",
    shortForm: "ショート",
    lifeFourCut: "人生4コマ",
    settings: "設定",
    logout: "ログアウト",
    petSelect: "ペット選択",
    currencyStore: "🥕 購入",
    expand: "開く",
    collapse: "閉じる",
    themeLight: "ライトモードへ",
    themeDark: "ダークモードへ",
    language: "言語",
    languageTitle: "言語設定",
    country: "国",
    countryTitle: "国設定",
    countrySearch: "国を検索",
    logoutConfirmTitle: "ログアウト",
    logoutConfirmBody: "ログアウトしますか？",
  },
  care: {
    feed: "ごはん",
    play: "あそぶ",
    clean: "おそうじ",
    hunger: "おなか",
    energy: "げんき",
    awake: "ねむけ",
    close: "閉じる",
  },
  // 動物idごとの表示名（ペットカタログ）。
  animals: {
    sloth: "ナマケモノ",
    cow: "乳牛",
    bull: "雄牛",
    moose: "ヘラジカ",
    monkey: "サル",
    bulldog: "ブルドッグ",
    cat: "ネコ",
    bear: "クマ",
    deer: "シカ",
    dog: "イヌ",
    dog2: "イヌ2",
    donkey: "ロバ",
    elephant: "ゾウ",
    fox: "キツネ",
    hippo: "カバ",
    horse: "ウマ",
    koala: "コアラ",
    lion: "ライオン",
    rhino: "サイ",
    panda: "パンダ",
    pig: "ブタ",
    rabbit: "ウサギ",
    raccoon: "アライグマ",
    sheep: "ヒツジ",
    squirrel: "リス",
    tiger: "トラ",
    unicorn: "ユニコーン",
    zebra: "シマウマ",
  },
  fourcut: {
    title: "人生4コマ",
    subtitle: "今のペットのランダムモーションを4コマで撮影。",
    shoot: "撮影する",
    reshoot: "撮り直す",
    download: "PNG保存",
    shootHint: "「撮影する」をタップ",
    rerollTip: "コマをクリックするとそのコマだけ撮り直し。",
    pattern_solid: "単色",
    pattern_gradient: "グラデーション",
    pattern_dots: "ドット",
    pattern_stripes: "ストライプ",
  },
  settings: {
    title: "設定",
    tabAccount: "アカウント設定",
    tabBroadcast: "配信設定",
    nickname: "ニックネーム",
    profile: "プロフィール画像",
    profileEdit: "プロフィール画像の変更",
    profileTabUrl: "URL入力",
    profileTabUpload: "アップロード",
    profileUrlHint: "https:// で始まる外部画像のURL",
    profileUrlInvalid: "https:// で始まるURLを入力してください。",
    profileUploadHint: "画像は自動的に小さくリサイズしてアップロードします。",
    cropHint: "円の中に入れたい部分をドラッグ・拡大して合わせてください。",
    profileSaved: "プロフィール画像を変更しました。",
    profileFailed: "プロフィール画像の変更に失敗しました。",
    passwordChange: "パスワード変更",
    newPassword: "新しいパスワード（6文字以上）",
    confirmPassword: "新しいパスワード（確認）",
    change: "変更",
    language: "言語",
    screenPosition: "配信画面設定（位置）",
    screenScale: "配信画面設定（サイズ）",
    nicknameSaved: "ニックネームを変更しました。",
    nicknameFailed: "ニックネームの変更に失敗しました。",
    pwTooShort: "パスワードは6文字以上で入力してください。",
    pwMismatch: "パスワード（確認）が一致しません。",
    pwChanged: "パスワードを変更しました。",
    pwFailed: "パスワードの変更に失敗しました。",
  },
  categoryHub: {
    subtitle: "メニューを選んでください。",
    // 仮の説明（後で修正）
    desc: {
      petStore: "アクセサリーや食べ物などを購入",
      hospital: "ペットのコンディションを検査・治療",
      ranking: "他のペットとレベルを競う",
      gather: "🥕を集めて購入",
      myItems: "所持アイテムを確認",
      petSelect: "配信するペットを選ぶ",
      petSetting: "ペットの名前・背景などを設定",
      training: "ペットに反応を教える",
      motion: "ペットのリアクションを選んで再生",
      viewerAffinity: "視聴者との親密度を確認",
      broadcast: "OBSリンク発行・配信をリアルタイム制御",
      broadcastGame: "視聴者参加型のミニゲームで楽しむ",
      broadcastManage: "CHZZK・Twitchなどを連携",
      socialBroadcast: "背景を飾ってペットを自由に配置できます",
      shortForm: "ペットでショート動画を作成",
      lifeFourCut: "今のペットの人生4コマを撮影",
      makeReaction: "チャットや投げ銭に反応するリアクションを作成",
      upload: "配信で使う音楽・字幕をアップロード",
    },
  },
  broadcastGame: {
    title: "配信ゲーム",
    subtitle: "視聴者が参加できるミニゲームで配信を盛り上げましょう。",
    wordGuessName: "お題当て",
    wordGuessDesc: "視聴者がチャットでお題を当てます",
    play: "はじめる",
  },
  broadcastManage: {
    title: "プラットフォーム連携",
    subtitle: "配信プラットフォームを連携すると、チャット/投げ銭/サブスクを受け取ってペットが反応します。",
    tabChzzk: "CHZZK",
    tabTwitch: "Twitch",
    tabSoop: "SOOP",
    tabYoutube: "YouTube",
    tabInstagram: "Instagramライブ",
    tabChzzkRelay: "CHZZK（リレー）",
    chzzkTitle: "CHZZKアカウント連携",
    chzzkDesc: "NaverアカウントでCHZZKを連携すると、公式APIでチャット/投げ銭/サブスクを受け取れます。",
    connected: "連携済み",
    notConnected: "未連携",
    useInBroadcast: "有効化",
    chzzkConnect: "CHZZKで連携",
    disconnect: "連携解除",
    connectShort: "連携",
    changeShort: "変更",
    disconnectShort: "解除",
    twitchTitle: "Twitchチャンネル連携",
    twitchDesc: "Twitchチャンネル名を入力すると、匿名でチャットを受け取ります。（ログイン不要）",
    twitchPlaceholder: "Twitchチャンネル名（例：ninja）",
    twitchConnect: "Twitch連携",
    twitchChange: "チャンネル変更",
    soopTitle: "SOOP連携",
    youtubeTitle: "YouTube連携",
    instagramTitle: "Instagramライブ連携",
    channelChecking: "チャンネル情報を確認中",
    confirmDisconnectChzzk: "CHZZKの連携を解除しますか？",
    confirmDisconnectTwitch: "Twitchの連携を解除しますか？",
    chzzkConnected: "CHZZKアカウントを連携しました。",
    chzzkConnectFailed: "CHZZK連携を開始できません。",
    chzzkDisconnected: "CHZZKの連携を解除しました。",
    twitchConnected: "Twitchチャンネルを連携しました。",
    twitchConnectFailed: "Twitch連携に失敗しました。",
    twitchDisconnected: "Twitchの連携を解除しました。",
    disconnectFailed: "連携解除に失敗しました。",
    settingChangeFailed: "設定の変更に失敗しました。",
    callbackConnected: "CHZZKアカウントを連携しました。",
    callbackExpired: "連携リクエストの有効期限が切れました。もう一度お試しください。",
    callbackError: "CHZZK連携に失敗しました。",
    relayTitle: "CHZZKリレー（管理者）",
    relayDesc:
      "他のストリーマーのチャンネル名を入力すると、リレーサーバーが視聴者として入室し公開チャットを取得します。（配信中のチャンネルのみ）",
    relayPlaceholder: "対象CHZZKチャンネル名",
    relayConnect: "リレー接続",
    relayChange: "チャンネル変更",
    relayConnected: "リレー対象チャンネルを設定しました。",
    relayConnectFailed: "リレーチャンネルの設定に失敗しました。",
    relayNotFound: "その名前のCHZZKチャンネルが見つかりません。",
    relayDisconnected: "リレー接続を解除しました。",
    confirmDisconnectRelay: "リレー接続を解除しますか？",
  },
  onboarding: {
    welcome: "ようこそ 🌈",
    nicknamePrompt: "バーチュペットで使うニックネームを決めてください。",
    nickname: "ニックネーム",
    agreeTerms: "利用規約およびプライバシーポリシーに同意します",
    next: "次へ",
    nicknameSaveError: "ニックネームの保存中にエラーが発生しました。しばらくしてからもう一度お試しください。",
    metaTitleSuffix: "の情報を入力してください ✍️",
    name: "名前",
    age: "年齢",
    gender: "性別",
    job: "職業",
    planet: "惑星",
    start: "はじめる",
    required: "必須項目です",
    agePositive: "1以上の数字",
    gachaTitlePrefix: "運命の",
    gachaTitleSuffix: "を引いてみましょう 🎰",
    draw: "ガチャ",
    reroll: "もう一度引く",
    startWithThis: "この子ではじめる →",
    viewAll: "すべて見る",
    lowBalance: "🥕が足りず、もう一度引くのは難しいです。今の子ではじめられます！",
    catalogTitle: "バーチュペット図鑑",
    petCreateError: "ペットの作成中にエラーが発生しました。しばらくしてからもう一度お試しください。",
  },
  pricing: {
    title: "料金",
    subtitle:
      "バーチュペットは配信オーバーレイ用のバーチャルペットサービスです。以下はアプリ内通貨 にんじん(🥕) の購入価格です。にんじんはペットの育成・アイテムなどに使うデジタル通貨です。",
    disclaimer:
      "にんじんはVirtupetソフトウェア内でのみ使用される消耗型アプリ内アイテムです。現金への払い戻しや、配信者など第三者への支払いは行われず、投げ銭・寄付機能ではありません。",
    carrots: "{n} にんじん",
    bonus: "+{n} ボーナス",
    taxIncluded: "税込",
    note1: "表示価格は税込で、最終的な金額・通貨・現地税は決済時に確定します。",
    note2: "にんじんはデジタル財（消耗型アプリ内アイテム）で、購入後アカウントに付与されます。",
    note3: "決済通貨は表示言語／地域により異なります（한국어=₩ / English=$ / 日本語=¥）。",
    contact: "決済・返金のお問い合わせ:",
  },
  footer: {
    rights: "All rights reserved.",
    contact: "お問い合わせ",
    terms: "利用規約",
    privacy: "プライバシー",
    refunds: "返金ポリシー",
  },
};
